import { useCallback } from "react";

import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { funnelUtils } from "@v2/trpc/routes/funnel";
import { nextJSProjectRouter } from "@v2/trpc/routes/nextJSProject";
import { useNavigate } from "react-router-dom";

export const useResetFiles = () => {
  const projectId = useCurrentProjectId();
  const navigate = useNavigate();
  const { mutate: resetFilesMutate, isPending: isLoadingFilesReset } =
    nextJSProjectRouter.resetFiles.useMutation({
      onSuccess: async () => {
        await funnelUtils.list.invalidate({
          projectId,
        });
        navigate(`/shops/${projectId}/funnels`);
      },
    });
  const resetFiles = useCallback(() => {
    if (!projectId) {
      return;
    }
    resetFilesMutate({
      projectId,
    });
  }, [resetFilesMutate, projectId]);
  return { resetFiles, isLoadingFilesReset };
};
